const key = 'ACCOUNTS_';

exports.ACCOUNTS_CLIENTS_SUCCESS = `${key}CLIENTS_SUCCESS`;
exports.ACCOUNTS_CLIENTS_LOADING = `${key}CLIENTS_LOADING`;
exports.ACCOUNTS_CLIENTS_ERROR = `${key}CLIENTS_ERROR`;
exports.ACCOUNTS_SET_CLIENT = `${key}SET_CLIENT`;

exports.ACCOUNTS_USERS_SUCCESS = `${key}USERS_SUCCESS`;
exports.ACCOUNTS_USERS_LOADING = `${key}USERS_LOADING`;
exports.ACCOUNTS_USERS_ERROR = `${key}USERS_ERROR`;
exports.ACCOUNTS_SET_USER = `${key}SET_USER`;
exports.ACCOUNTS_USE_USERS_CURRENT_CLIENT_AGAIN = `${key}USE_USERS_CURRENT_CLIENT_AGAIN`;
